// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.application-info__text {
  margin-bottom: var(--spacing4);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/configured-service-add-edit/application-info/application-info.component.scss"],"names":[],"mappings":"AAAA;EACI,8BAAA;AACJ","sourcesContent":[".application-info__text {\n    margin-bottom: var(--spacing4);\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
